exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header.bg-dark[data-v-9dfd8a64]{background-color:#f6f7f7!important;color:#000!important;padding:5px 10px}.link-btn[data-v-9dfd8a64]{color:#eaedef!important;border-color:#eaedef!important}@media screen and (max-width:768px){.card[data-v-9dfd8a64]{margin-left:5px!important;width:185px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9dfd8a64","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/displayers/display-user.vue
// module id = 1658
// module chunks = 0